module.exports = __webpack_public_path__ + "img/luv-logo-standard.937c1a1a.png";